import React from 'react'
import PropTypes from 'prop-types'
import { ButtonIcon, LocalizedText, Rows, FileIcon } from 'src/components'
import { mergeProps } from 'src/util'
import styles from './FileDropInput.scss'

const FileDropInput = ({ value, inputProps, onOpen, ...domProps }) => (
  <Rows
    layout="auto"
    align="center"
    justify="center"
    gap="1rem"
    {...mergeProps()({ className: styles.fileDropZone }, domProps)}
  >
    <input {...inputProps} />
    <span className={styles.dropHint}>
      <LocalizedText id="WEB_DRAG_DROP_ZONE" />
    </span>
    <ButtonIcon icon={FileIcon} onClick={onOpen}>
      <LocalizedText id="WEB_SELECT_FILE" />
    </ButtonIcon>
    {value && !!value.length && (
      <Rows align="center">
        <b>
          <LocalizedText id="WEB_FILES" /> :
        </b>
        <Rows gap="0">
          {value.map(({ name }) => (
            <span key={name}>- {name}</span>
          ))}
        </Rows>
      </Rows>
    )}
  </Rows>
)

FileDropInput.propTypes = {
  inputProps: PropTypes.object,
  value: PropTypes.array,
  onOpen: PropTypes.func,
}

export default FileDropInput
